import axios from "axios"

export default {
    async Create(payload){
        const response = await axios.post('/api/sgkexitapproval/level/create',payload)
        return response
    },
    async CreateTitle(payload){
        const response = await axios.post('/api/sgkexitapproval/level/title/create',payload)
        return response
    },
    async Update(payload){
        const response = await axios.post('/api/sgkexitapproval/level/update',payload)
        return response
    },
    async Delete(data){
        const response = await axios.get(`/api/sgkexitapproval/level/delete/${data}`)
        return response
    },
    async DeleteTitle(data){
        const response = await axios.get(`/api/sgkexitapproval/level/title/delete/${data}`)
        return response
    },
    async List(payload){
        const response = await axios.post('/api/sgkexitapproval/level/list',payload)
        return response
    }
}